module.exports = __webpack_public_path__ + "application.32a67c0497f66fb407a3b545798efb5a.svg";